<main class="agents-page">
    <section class="agents-page__intro">
        <h1 class="agents-page__title">Meet our agents</h1>
        <p class="agents-page__subtitle">Local knowledge. Local experts.</p>
    </section>

    <section class="agents-page__content">
        <p *ngIf="loading()" class="agents-page__status">Loading agents...</p>
        <p *ngIf="!loading() && loadError()" class="agents-page__status agents-page__status--error">
            Could not load agents. Please try again later.
        </p>

        <div *ngIf="!loading() && !loadError() && !hasAgents()" class="agents-page__empty">
            Agent profiles are being updated. Check back soon.
        </div>

        <div *ngIf="!loading() && !loadError() && hasAgents()" class="agents-page__grid">
            <article *ngIf="founder() as founderProfile" class="agent-card agent-card--founder">
                <div class="agent-card__photo-wrap">
                    <img
                        class="agent-card__photo"
                        [src]="founderProfile['img-url']"
                        [alt]="founderProfile.name" />
                </div>
                <div class="agent-card__body">
                    <span class="agent-card__badge">Broker / Owner</span>
                    <h2 class="agent-card__name">{{ founderProfile.name }}</h2>
                    <p class="agent-card__description" *ngIf="founderProfile.description">{{ founderProfile.description }}</p>
                </div>
                <div class="agent-card__actions">
                    <a
                        class="agent-card__btn agent-card__btn--profile"
                        [routerLink]="['/agents', founderProfile.slug]">
                        More info
                    </a>
                    <a class="agent-card__btn agent-card__btn--primary" href="tel:{{ founderProfile.phone }}">
                        <app-icon name="call" />
                        Call
                    </a>
                    <a class="agent-card__btn agent-card__btn--secondary" href="mailto:{{ founderProfile.email }}">
                        <app-icon name="email" />
                        Email
                    </a>
                </div>
            </article>

            <article *ngFor="let agent of agents()" class="agent-card">
                <div class="agent-card__photo-wrap">
                    <img
                        class="agent-card__photo"
                        [src]="agent['img-url']"
                        [alt]="agent.name" />
                </div>
                <div class="agent-card__body">
                    <h2 class="agent-card__name">{{ agent.name }}</h2>
                    <p class="agent-card__description" *ngIf="agent.description">{{ agent.description }}</p>
                </div>
                <div class="agent-card__actions">
                    <a
                        class="agent-card__btn agent-card__btn--profile"
                        [routerLink]="['/agents', agent.slug]">
                        More info
                    </a>
                    <a class="agent-card__btn agent-card__btn--primary" href="tel:{{ agent.phone }}">
                        <app-icon name="call" />
                        Call
                    </a>
                    <a class="agent-card__btn agent-card__btn--secondary" href="mailto:{{ agent.email }}">
                        <app-icon name="email" />
                        Email
                    </a>
                </div>
            </article>
        </div>
    </section>
</main>

